<template>
  <div>
    <el-container>
      <el-aside class="home-aside" width="240px" v-if="$route.path !== '/home/payment'">
        <div class="aside-container">
          <el-menu :router="true" :default-active="currentIndex" @select="handleMenuSelect">
            <template v-for="(item, index) in menus">
              <el-submenu v-if="item.children" :key="index" :index="'' + (index + 1)">
                <template slot="title">
                  <div class="menu-item" :style="item.style">
                    <p><i class="menu_icon" :class="item.icon"></i>{{ item.title }}</p>
                  </div>
                </template>
                <el-menu-item-group>
                  <template slot="title"></template>
                  <template v-for="(i, j) in item.children">
                    <el-menu-item :key="j" :index="(index + 1) + '-' + (j + 1)" :route="i.route"><i class="menu_icon"
                        :class="i.icon"></i>{{ i.title }}</el-menu-item>
                  </template>
                </el-menu-item-group>
              </el-submenu>
              <el-menu-item v-else :key="index" :index="'' + (index + 1)" :route="item.route" :class="{ 'custom-menu-item': item.isOpen }">
                <template slot="title">
                  <div class="menu-item" :style="item.style">
                    <p>
                      <span v-if="item.svgIcon" class="menu_icon svg-icon" v-html="item.svgIcon"></span>
                      <i v-else class="menu_icon" :class="item.icon"></i>
                      {{ item.title }}
                    </p>
                  </div>
                </template>
              </el-menu-item>
            </template>
            <el-menu-item index="/home/findcontents">
              <span class="menu_icon svg-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" stroke-width="2"/>
                  <path d="M8 8H16M8 12H14M8 16H12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  <circle cx="17" cy="17" r="3" fill="currentColor"/>
                  <path d="M16 17L18 17M17 16L17 18" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </span>
              <span slot="title">Find Contents</span>
            </el-menu-item>
            <el-menu-item
              v-if="user_type === 'student'"
              index="mycontents"
              :route="{ path: '/home/mycontents' }"
            >
              <span class="menu_icon svg-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H14L21 10V19C21 20.1046 20.1046 21 19 21Z" stroke="currentColor" stroke-width="2"/>
                  <path d="M14 3V10H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="12" cy="15" r="1.5" fill="currentColor"/>
                  <path d="M10 15C10 15 10.5 17 12 17C13.5 17 14 15 14 15" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
                </svg>
              </span>
              <span slot="title">My Contents</span>
            </el-menu-item>
            <el-menu-item
              v-if="user_type === 'student' || user_type === 'advisor' || user_type === 'schoolAdmin'"
              index="supporttickets"
              :route="{ path: '/home/supporttickets' }"
            >
              <span class="menu_icon svg-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="12" cy="10" r="1" fill="currentColor"/>
                  <circle cx="8" cy="10" r="1" fill="currentColor"/>
                  <circle cx="16" cy="10" r="1" fill="currentColor"/>
                </svg>
              </span>
              <span slot="title">Support Tickets</span>
            </el-menu-item>
          </el-menu>
          
          <div 
            v-if="user_type === 'schoolAdmin' || user_type === 'advisor'"
            class="registration-link-button"
            @click="copyRegistrationLink"
          >
            <i class="el-icon-link menu_icon"></i>
            <span>Student Registration Link for Your School</span>
          </div>
        </div>
      </el-aside>
      <el-main class="home-content">
        <div style="flex: 1; overflow-y: auto">
          <keep-alive include="record">
            <router-view></router-view>
          </keep-alive>
        </div>
        <div style="
            width: 100%;
            height: 50px;
            text-align: center;
            line-height: 50px;
            color: #cccccc;
            font-size: 16px;
            font-weight: 400;
          ">
          {{ currenrYear }} Extracurricular Activity Excellence | All Rights Reserved
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import "../assets/common/common.css";
import "../assets/common/font.css";
import { getUserType, isTestUser, getUserId, setTargetType } from "../utils/store";
export default {
  name: "Home",
  data() {
    return {
      currenrYear: '',
      currentIndex: '',
      user_type: getUserType(),

      menus: [
        
      ],
    };
  },
  created() {
    setTargetType('student')
    this.currenrYear = new Date().getFullYear()
    this.buildMenus()

    this.$root.$on('user-logged-in', this.handleUserLoggedIn)
    this.$globalMessage.$on('homeNavMenuChanged', (res) => {
      this.homeNavMenuChanged(res)
    })
  },
  mounted() {
    this.currentIndex = '' + sessionStorage.getItem('currentIndex') || '1';
  },
  beforeDestroy() {
    this.$root.$off('user-logged-in', this.handleUserLoggedIn)
  },
  methods: {
    handleUserLoggedIn() {
      this.user_type = getUserType()
      this.buildMenus()
    },
    buildMenus() {
      if (getUserType() == 'schoolAdmin') {
        this.menus = [
        {
          selected: false,
          title: "School Clubs",
          route: "/home/schoolclubs",
          svgIcon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L2 7V12C2 17.55 6.84 22.74 12 24C17.16 22.74 22 17.55 22 12V7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="8" cy="11" r="1.5" fill="currentColor"/>
            <circle cx="12" cy="11" r="1.5" fill="currentColor"/>
            <circle cx="16" cy="11" r="1.5" fill="currentColor"/>
            <path d="M8 15C8 15 9.5 17 12 17C14.5 17 16 15 16 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>`,
        },
        {
          selected: false,
          title: "Club Advisers",
          route: "/home/clubadvisors",
          svgIcon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="2"/>
            <path d="M6 21V19C6 16.7909 7.79086 15 10 15H14C16.2091 15 18 16.7909 18 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M15 8L18 5L20 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`,
        },
        {
          selected: false,
          title: "Discover Clubs",
          route: "/home/discoverclubs",
          svgIcon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2"/>
            <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M11 8L12 11L15 12L12 13L11 16L10 13L7 12L10 11L11 8Z" fill="currentColor"/>
          </svg>`,
        },
        {
          selected: false,
          title: "Subscriptions",
          route: "/home/subscriptionManagement",
          svgIcon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="2"/>
            <path d="M3 10H21" stroke="currentColor" stroke-width="2"/>
            <path d="M7 15H13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>`,
        },

      ];
      return;
    }

    if (getUserType() === 'admin') {
      this.menus = [
        {
          selected: false,
          title: "AccountForms",
          route: "/home/adminform",
          svgIcon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="3" width="16" height="18" rx="2" stroke="currentColor" stroke-width="2"/>
            <path d="M8 7H16M8 11H16M8 15H13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <circle cx="16" cy="16" r="4" fill="currentColor"/>
            <path d="M14.5 16L15.5 17L17.5 15" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`,
        },
        {
          selected: false,
          title: "EntryList",
          route: "/home/admin-enties",
          svgIcon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" stroke-width="2"/>
            <path d="M8 8H16M8 12H16M8 16H12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>`,
        },

      ];
      return;
    } else if (getUserType() === "advisor") {
      this.menus = [
        {
          selected: false,
          title: "My Clubs",
          route: "/home/adviserclubs",
          svgIcon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="3.5" fill="currentColor"/>
            <circle cx="17" cy="7" r="3.5" fill="currentColor"/>
            <circle cx="12" cy="17" r="3.5" fill="currentColor"/>
            <path d="M7 7L12 17M17 7L12 17" stroke="currentColor" stroke-width="2.5"/>
          </svg>`,
        },
        {
          selected: false,
          title: "Discover Clubs",
          route: "/home/discoverclubs",
          svgIcon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2"/>
            <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M11 8L12 11L15 12L12 13L11 16L10 13L7 12L10 11L11 8Z" fill="currentColor"/>
          </svg>`,
        },
        {
          selected: false,
          title: "Subscriptions",
          route: "/home/subscriptionManagement",
          svgIcon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="2"/>
            <path d="M3 10H21" stroke="currentColor" stroke-width="2"/>
            <path d="M7 15H13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>`,
        },
      ];

      return;
    }
    if (getUserType() == "student") {

      this.menus = [
        {
          selected: false,
          title: "My Clubs",
          route: "/home/studentclubs",
          svgIcon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="3.5" fill="currentColor"/>
            <circle cx="17" cy="7" r="3.5" fill="currentColor"/>
            <circle cx="12" cy="17" r="3.5" fill="currentColor"/>
            <path d="M7 7L12 17M17 7L12 17" stroke="currentColor" stroke-width="2.5"/>
          </svg>`,
        },
        {
          selected: false,
          title: "School Clubs",
          route: "/home/schoolclubs",
          svgIcon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L2 7V12C2 17.55 6.84 22.74 12 24C17.16 22.74 22 17.55 22 12V7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="8" cy="11" r="1.5" fill="currentColor"/>
            <circle cx="12" cy="11" r="1.5" fill="currentColor"/>
            <circle cx="16" cy="11" r="1.5" fill="currentColor"/>
            <path d="M8 15C8 15 9.5 17 12 17C14.5 17 16 15 16 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>`,
        },
      ];
      return;
    }

    // Not logged in (e.g. opened the claim link before login) — no menu yet.
    this.menus = []
    },

    homeNavMenuChanged(route_path) {
      let selectedIndex = -1
      for (let i = 0; i < this.menus.length; i++) {
        let menu = this.menus[i]
        menu.selected = false
        let selected = (menu.route == route_path)
        if (selected == true) {
          selectedIndex = i
        }
      }
      if (selectedIndex >= 0) {
        this.menus[selectedIndex].selected = true
      }
      this.currentIndex = '' + (selectedIndex + 1)
      this.$forceUpdate()
    },

    handleMenuSelect(index) {
      console.log(index, '=-=-=-')
      this.currentIndex = index;
      sessionStorage.setItem('currentIndex', index);
    },

    copyRegistrationLink() {
      const schoolId = getUserId(); // Assuming this gets the school's ID
      const registrationLink = `${window.location.origin}/#/student-registration?school_id=${schoolId}`;
      
      navigator.clipboard.writeText(registrationLink)
        .then(() => {
          this.$message({
            message: 'Registration link copied to clipboard!',
            type: 'success'
          });
        })
        .catch(() => {
          this.$message({
            message: 'Failed to copy link',
            type: 'error'
          });
        });
    },
  },
};
</script>

<style scoped lang="less">
::-webkit-scrollbar {
  display: none;
}

.home-content {
  height: calc(100vh - 50px);
  width: 100%;
  display: flex;
  flex-direction: column;
}

.home-aside {
  overflow-y: auto;
  height: calc(100vh - 50px);
  background: #F9F9F9;
}

.menu-item {
  display: flex;
  align-items: center;
}

.menu_icon {
  display: inline-block;
  margin-right: 4px;
  width: 24px;
  height: 24px;
}

.svg-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;

  svg {
    width: 20px;
    height: 20px;
    color: inherit;
  }
}


.custom-menu-item {
  background-color: var(--c-primary) !important;
}

.el-menu-item.is-active {
  color: #FF6450 !important;
}

.el-submenu.custom-menu-item .el-submenu__title {
  background-color: var(--c-primary) !important;
  color: white !important;
}

.el-submenu.custom-menu-item .el-submenu__title:hover {
  background-color: var(--c-primary) !important;
}

.aside-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.registration-link-button {
  margin-top: auto;
  padding: 12px 16px;
  background: #FF6450;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.3s;
  border-radius: 4px;
  margin: 12px;

  &:hover {
    background: #ff7a6b;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(255, 100, 80, 0.3);
  }

  .menu_icon {
    margin-right: 8px;
    color: white;
  }
}
</style>